(function() {

    "use strict";

    document.addEventListener('DOMContentLoaded', () => {

        const DEV = 0;

        const elements = document.querySelectorAll('[back-asset]');
        DEV && log('elements', elements)
        
        elements.forEach(element => {

            element.classList.add('not-visible');

            const url = appInfo.theme + 'assets/images/' + element.getAttribute('back-asset');
            DEV && log('url', url)

            const options = {
                // root: $(window),
                // rootMargin: "25px",
                threshold: [0.1]
            };

            const observer = new IntersectionObserver(onChange, options);
            observer.observe(element);

            function onChange(changes) {
                changes.forEach(change => {
                    if (change.intersectionRatio > 0.1) {
                        const el = change.target;

                        DEV && log('change', change);
                        DEV && log('el', el);
                        DEV && log('Item visible');

                        const image = new Image();
                        image.src = url;

                        image.onload = function() {
                            el.style.backgroundImage = "url(" + url + ")";
                            el.classList.add('fade-in-when-visible');
                            el.classList.remove('not-visible');
                            observer.unobserve(el);
                            
                            // Assuming loaderOff is a global function or can be handled differently
                            if (typeof window.loaderOff === 'function') {
                                window.loaderOff();
                            }
                        };
                    }
                });
            }
        });
    });
})();